function toggleMobileMenu() {
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuBg = document.getElementById('mobileMenuBg');
    if (mobileMenu.classList.contains('active')) {
        mobileMenu.classList.remove('active');
        mobileMenuBg.classList.remove('active');
        document.body.style.overflowY = 'auto'; // Prevent scrolling
    } else {
        mobileMenu.classList.add('active');
        mobileMenuBg.classList.add('active');
        document.body.style.overflowY = 'hidden'; // Prevent scrolling
    }
}

document.getElementById('mobileMenuBg').addEventListener('click', function () {
    toggleMobileMenu();
});

document.querySelector('.hamburger-btn').addEventListener('click', function () {
    toggleMobileMenu();
});

document.getElementById('closeMenuBtn').addEventListener('click', function () {
    toggleMobileMenu();
});